import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import {
  flowInvoiceGetGap,
  FlowInvoiceInsight,
} from 'src/app/_types/billing.types';
import { GapDisplayComponent } from 'src/app/Dashboard/billing/gap-display/gap-display.component';

@Component({
  selector: 'app-flow-invoice-gap-renderer',
  standalone: true,
  imports: [GapDisplayComponent],
  styles: `
    :host {
      display: flex;
      align-items: center;
    }
  `,
  template: `<app-gap-display [gap]="gap()" />`,
})
export class FlowInvoiceGapRendererComponent
  implements ICellRendererAngularComp
{
  readonly gap = signal<{ amount: number; pct: number } | null>(null);

  agInit(params: ICellRendererParams<FlowInvoiceInsight>): void {
    const invoice = params.data;
    const gap = invoice ? flowInvoiceGetGap(invoice) : null;
    this.gap.set(!gap || Math.abs(gap.amount) < 0.01 ? null : gap);
  }

  refresh(): boolean {
    return false;
  }
}
